import { render } from "./workshopTaskCard.vue?vue&type=template&id=26a7d858&scoped=true"
import script from "./workshopTaskCard.vue?vue&type=script&lang=js"
export * from "./workshopTaskCard.vue?vue&type=script&lang=js"

import "./workshopTaskCard.vue?vue&type=style&index=0&id=26a7d858&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a7d858"]])

export default __exports__